import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Website} from "../../../website";
import {Product, ProductOrigin, ProductType} from "../../../product";
import {Permissions} from "../../../../../user/permissions";
import {UserSubscription, UserSubscriptionCategory} from "../../../../../user/user-subscription";
import * as fromStore from "../../../../../store";
import {Store} from "@ngrx/store";
import {ActivityAction, ActivityStatus, IActivity} from "../../../../../activities/activity";
import {DbStoreState} from "../../../../../store/reducers";
import {Observable, map} from "rxjs";
import {Router} from "@angular/router";

@Component({
    selector: 'db-available-theme',
    templateUrl: './available-theme.component.html',
    styleUrls: ['./available-theme.component.scss'],
    standalone: false
})
export class AvailableThemeComponent implements OnInit {

  public ActivityAction = ActivityAction;
  public ActivityStatus = ActivityStatus;

  public ProductType: any = ProductType;

  @Input() website: Website;
  @Input() product: Product;
  @Input() userPermissions: Permissions;
  @Input() userSubscriptions: UserSubscription[];
  @Input() currentSubscription: UserSubscription;

  @Input() activeTab: string;
  @Output() toggled: EventEmitter<void>;

  public isManagable: boolean;

  public isWpProductInstalled$: Observable<boolean>;

  public ongoingActivity$: Observable<IActivity>;
  public ongoingActivityStatusClass$: Observable<string>;

  constructor(
    private _store: Store<DbStoreState>,
    private _router: Router
  ) {
    this.toggled = new EventEmitter<void>();
  }

  ngOnInit() {
    this.isManagable = !this.website?.isLocalhost && this.userPermissions?.canManageContent;

    this.isWpProductInstalled$ = this._store.select(fromStore.getWebsiteTheme(this.website?.id, this.product?.slug))
    .pipe(map((product: Product) => {
        return !!product && (product.origin === ProductOrigin.WORDPRESS || (product.origin === ProductOrigin.TEN_WEB && !product.paidVersionInstalled));
      }));

    this.ongoingActivity$ = this._store.select(fromStore.getProductOngoingActivity(this.website?.id, this.product?.slug));
    this.ongoingActivityStatusClass$ = this.ongoingActivity$.pipe(map((activity: IActivity): string => {
      if (!activity) {
        return '';
      }

      if (activity.status === ActivityStatus.DONE) {
        return 'success';
      }
      if (activity.status === ActivityStatus.FAILED) {
        return 'danger';
      }

      return 'info';
    }));
  }

  public install(): void {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.product],
      action: ActivityAction.INSTALL,
      network: 0
    }));
  }

  public showPremiumPluginDialog(): void {
    const activeTab = (this.currentSubscription.category === UserSubscriptionCategory.STARTER || this.currentSubscription.category === UserSubscriptionCategory.REGISTERED) ? 'platform' : 'bundle';
    this._router.navigate(['/upgrade-plan'], { queryParams: {plugin_slug: this.product.slug, plugin_title: this.product.title, active_tab: activeTab } });
  }

}
